import { useTranslation } from '@lyearn/i18n';
import { CheckmarkCircleFill, RadioButtonOffFill } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';
import { getErrorMessage } from '@/modules/auth/utils/errorMessage';

const CheckListItem: React.FC<{ className?: string; label?: string; checked: boolean }> = ({
  checked,
  label,
  className = 'flex items-center my-8',
}) => {
  const { t } = useTranslation();
  const getI18nErrorMessage = getErrorMessage(t);

  return (
    <Box className={className}>
      {checked ? (
        <CheckmarkCircleFill className="h-16 w-16" fillColorToken="icon-success-light" />
      ) : (
        <RadioButtonOffFill className="h-16 w-16" fillColorToken="icon-placeholder" />
      )}
      <Typography
        className="ms-8"
        color={checked ? undefined : 'text-text-placeholder'}
        variant="body-short-02">
        {getI18nErrorMessage(label)}
      </Typography>
    </Box>
  );
};

export default CheckListItem;
